import React from "react";
import {
  Card,
  CardContent,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputAdornment,
  Button,
  Stack,
  Box,
  Typography,
} from "@mui/material";
import {
  Search as SearchIcon,
  Clear as ClearIcon,
  People as PeopleIcon,
} from "@mui/icons-material";

const FilterBar = ({
  searchTerm,
  onSearchChange,
  employmentStatusFilter,
  onEmploymentStatusChange,
  activeFilter,
  onActiveFilterChange,
  onClearFilters,
  hasActiveFilters,
  totalCount,
  isMobile,
}) => {
  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Grid container spacing={2} alignItems="center">
          <Grid item size={{ lg: 5, md: 5, sm: 12, xs: 12 }}>
            <TextField
              fullWidth
              placeholder="Search by name, staff number, or email..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              size="small"
            />
          </Grid>
          <Grid item size={{ lg: 2, md: 2, sm: 6, xs: 12 }}>
            <FormControl fullWidth size="small">
              <Select
                value={employmentStatusFilter}
                onChange={(e) => onEmploymentStatusChange(e.target.value)}
                displayEmpty
              >
                <MenuItem value="">All Employment</MenuItem>
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="On Leave">On Leave</MenuItem>
                <MenuItem value="Suspended">Suspended</MenuItem>
                <MenuItem value="Retired">Retired</MenuItem>
                <MenuItem value="Terminated">Terminated</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item size={{ lg: 2, md: 2, sm: 6, xs: 12 }}>
            <FormControl fullWidth size="small">
              <Select
                value={activeFilter}
                onChange={(e) => onActiveFilterChange(e.target.value)}
                displayEmpty
              >
                <MenuItem value="">All Status</MenuItem>
                <MenuItem value="1">Active</MenuItem>
                <MenuItem value="0">Inactive</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item size={{ lg: 3, md: 3, sm: 12, xs: 12 }}>
            <Stack direction={{ xs: "column", sm: "row" }} alignItems={{ xs: "stretch", sm: "center" }} justifyContent={{ xs: "flex-start", md: "flex-end" }} spacing={1}>
              {hasActiveFilters && (
                <Button
                  size="small"
                  variant="outlined"
                  color="secondary"
                  startIcon={<ClearIcon />}
                  onClick={onClearFilters}
                  fullWidth={isMobile}
                >
                  Clear All
                </Button>
              )}
              <Box display="flex" alignItems="center" justifyContent={{ xs: "center", sm: "flex-start" }}>
                <PeopleIcon color="action" sx={{ mr: 1 }} />
                <Typography variant="body2" color="text.secondary">
                  Total: <Typography component="span" color="primary" fontWeight="bold">{totalCount}</Typography> teachers
                </Typography>
              </Box>
            </Stack>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default FilterBar;
